class EventBus extends EventTarget {
  emitProgress(filename, progress) {
    const event = new CustomEvent("progress", { detail: { filename, progress } });
    this.dispatchEvent(event);
  }

  onProgress(callback) {
    this.addEventListener("progress", (event) => {
      callback(event.detail.filename, event.detail.progress);
    });
  }

  offProgress(callback) {
    this.removeEventListener("progress", callback);
  }
}

export const eventBus = new EventBus();